<template>
  <Layout>
    <FormulateForm
      v-model="formValues"
      name="editable-table-form"
      ref="formRef"
      @submit="handleSubmit"
      :errors="formErrors"
    >
      <div class="mc-list-header">
        <PageHeader :title="title" />
        <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
          <div class="float-end">
            <b-button
              :disabled="loading"
              @click="$router.go(-1)"
              variant="outline-primary"
              class="mx-2"
            >
              <i class="mc-fa icon-outline_close"></i> {{ $t('global.cancel') }}
            </b-button>

            <b-button
              v-if="isUpdate"
              :disabled="loading"
              @click="
                $router.push({
                  name: 'Route Planning Update History',
                  params: { routeRecordId: $route.params.routeRecordId },
                })
              "
              variant="outline-primary"
              class="mx-2"
            >
              <i class="mc-fa icon-outline_file-text"></i> {{ $t('global.historyUpdate') }}
            </b-button>

            <b-dropdown
              toggle-tag="div"
              toggle-class="p-0 bg-transparent me-2 border-none"
              v-if="changeStatusList"
            >
              <template #button-content>
                <McButton
                  variant="secondary"
                  :text="$t('global.action.changeStatus')"
                  :icon="'icon-outline_chevron-down'"
                  icon-position="right"
                />
              </template>
              <b-dropdown-item
                v-for="statusList in changeStatusList"
                :key="statusList.id"
                @click="openModalChangeStatus(statusList)"
                >{{ statusList.label }}</b-dropdown-item
              >
            </b-dropdown>

            <b-button
              :disabled="loading"
              variant="primary"
              type="submit"
              v-if="!['done', 'cancelled', 'progress'].includes(status)"
            >
              <i class="mc-fa icon-outline_save"></i> {{ $t('global.save') }}
            </b-button>
          </div>
        </div>
      </div>
      <div class="mc-liveview mc-route__monitoring clearfix">
        <GoogleMap :geometry="geometry" />
        <SideBar @onGetRoute="onGetRoute" @updateStatus="changeStatus" />
      </div>
    </FormulateForm>
    <b-modal
      class="mc-modal"
      id="mc-modal-change-status"
      ref="mc-modal-change-status"
      :title="$t('global.action.changeStatus')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('global.text.modal.changeStatus3') }}
          {{ statusChanged.label }} ?
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            :text="$t('global.action.cancel')"
            class="me-2"
            @click="cancel()"
          />
          <McButton
            variant="primary"
            :text="$t('global.action.change')"
            @click="changeStatusPlan"
          />
        </div>
      </template>
    </b-modal>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import GoogleMap from './GoogleMap'
import SideBar from './SideBar'
import { CREATE_ROUTE_RECORD, UPDATE_ROUTE_RECORD } from '@/services/api/route/index.js'
import { Helper } from '@/mixin/helper.js'
import { MixPanel } from '@/mixin/mixpanel'
import McButton from '@/components/McButton'
import Swal from 'sweetalert2'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Route',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    SideBar,
    GoogleMap,
    McButton,
  },
  mixins: [Helper, MixPanel],
  status: '',

  data() {
    return {
      formValues: null,
      formErrors: {},
      geometry: {},
      loading: false,

      isUpdate: false,
      updateParam: {
        totalField: 4,
        indexField: -1,
      },
      oldData: null,
      status: '',
      statusChanged: '',
    }
  },

  computed: {
    title() {
      return !this.isUpdate
        ? this.$t('route.routePlaning.title') + ' ' + this.$t('global.new')
        : this.$t('global.action.change') + ' ' + this.$t('route.routePlaning.title')
    },

    changeStatusList() {
      if (this.status == 'scheduled') {
        return [
          {
            id: 'progress',
            label: this.$t('route.routePlaning.status.onTheWay'),
          },
          {
            id: 'done',
            label: this.$t('route.routePlaning.status.done'),
          },
          {
            id: 'cancelled',
            label: this.$t('route.routePlaning.status.canceled'),
          },
        ]
      } else if (this.status == 'progress') {
        return [
          {
            id: 'done',
            label: this.$t('route.routePlaning.status.done'),
          },
          {
            id: 'cancelled',
            label: this.$t('route.routePlaning.status.canceled'),
          },
        ]
      }

      return null
    },
  },

  watch: {
    formValues: {
      handler(newData) {
        if (this.updateParam.totalField != this.updateParam.indexField && this.isUpdate) {
          this.oldData = newData
          this.updateParam.indexField++
        }
      },
      deep: true,
    },
  },

  created() {
    if (this.$route.params.routeRecordId) {
      this.isUpdate = true
    }
  },

  methods: {
    onGetRoute(route) {
      this.geometry = route.data
    },

    changeStatus(status) {
      this.status = status
    },

    openModalChangeStatus(status) {
      this.statusChanged = status

      this.$bvModal.show('mc-modal-change-status')
    },

    async changeStatusPlan() {
      const self = this

      self.$apollo
        .mutate({
          mutation: UPDATE_ROUTE_RECORD,
          variables: {
            input: {
              routeRecordId: parseInt(self.$route.params.routeRecordId),
              oldData: {
                status: self.status,
              },
              newData: {
                status: self.statusChanged.id,
              },
            },
          },
        })
        .then((response) => {
          if (response.data.updateRouteRecord.isSuccessful) {
            this.$mcToast.success(this.$t('global.alert.text.changed'))
            this.loading = false
            const statusMap = {
              progress: 'Dalam Perjalanan',
              done: 'Selesai',
              cancelled: 'Dibatalkan',
            }
            const valueChangeStatus = statusMap[self.statusChanged.id] || 'Unknown'
            this.track(`Change Status "${valueChangeStatus}" on Route Planning`)
            this.$router.push({ name: 'Route Planning' })
          } else {
            const text = this.$t(
              `maintenance.errorMessages.${response.data.updateRouteRecord.errorName}`
            )
            Swal.fire({
              title: this.$t('route.alert.saveFailed'),
              text: text,
              imageUrl: require(`@/assets/images/alert-report-danger.png`),
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.loading = false
            })
          }
        })
    },

    async handleSubmit(data) {
      this.loading = true

      if (this.isUpdate) {
        this.$apollo
          .mutate({
            mutation: UPDATE_ROUTE_RECORD,
            variables: {
              input: {
                newData: {
                  expectedEndOn: this.momentToISOString(data.expectedEndTime),
                  expectedStartOn: this.momentToISOString(data.startOn),
                  routeId: data.route,
                  vehicleId: data.licensePlate,
                },
                oldData: {
                  expectedEndOn: this.momentToISOString(this.oldData.expectedEndTime),
                  expectedStartOn: this.momentToISOString(this.oldData.startOn),
                  routeId: this.oldData.route,
                  vehicleId: this.oldData.licensePlate,
                },
                routeRecordId: Number(this.$route.params.routeRecordId),
              },
            },
          })
          .then((response) => {
            if (response.data.updateRouteRecord.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.changed'))
              this.loading = false
              this.track('Change Route Planning')
              this.$router.push({ name: 'Route Planning' })
            } else {
              const text = this.$t(
                `maintenance.errorMessages.${response.data.updateRouteRecord.errorName}`
              )
              Swal.fire({
                title: this.$t('route.alert.saveFailed'),
                text: text,
                imageUrl: require(`@/assets/images/alert-report-danger.png`),
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.loading = false
              })
            }
          })
      } else {
        this.$apollo
          .mutate({
            mutation: CREATE_ROUTE_RECORD,
            variables: {
              input: {
                expectedEndOn: this.momentToISOString(data.expectedEndTime),
                expectedStartOn: this.momentToISOString(data.startOn),
                routeId: data.route,
                vehicleId: data.licensePlate,
              },
            },
          })
          .then((response) => {
            if (response.data.createRouteRecord.isSuccessful) {
              this.$mcToast.success(this.$t('liveView.text.dataSaved'))
              this.loading = false
              this.track('Create Route Planning')
              this.$router.push({ name: 'Route Planning' })
            } else {
              const text = this.$t(
                `maintenance.errorMessages.${response.data.createRouteRecord.errorName}`
              )
              Swal.fire({
                title: this.$t('route.alert.saveFailed'),
                text: text,
                imageUrl: require(`@/assets/images/alert-report-danger.png`),
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.loading = false
              })
            }
          })
      }
    },
  },
}
</script>
